import { t } from '../../i18n';

/**
 * Номер в интерфейсе: четыре знака с ведущими нулями и БЕЗ значка «№».
 *
 * Значка нет в макетах, а ведущие нули держат ширину: в списке версий и в
 * шапке досье номера стоят столбиком, и «версия 4» рядом с «версия 12»
 * сдвигала соседнюю дату на знак. Пятизначные номера не режем — до них ещё
 * дожить надо, а обрезанный номер хуже широкого.
 */
export function docNumber(value: number): string {
  return String(value).padStart(4, '0');
}

/**
 * Длинное число группами по три: «446 701 315».
 *
 * Так набран номер страницы на экране гостя — единственное, что человек
 * перепишет администратору руками, и девять цифр подряд он прочитает с
 * третьей попытки. Разделитель НЕРАЗРЫВНЫЙ: номер не должен ломаться на две
 * строки, сколько бы места ни осталось в карточке.
 *
 * Это не `docNumber`: тот добивает ведущими нулями до четырёх знаков, потому
 * что номера версий стоят в списке столбиком. Здесь номер один, и добивать
 * его нечем.
 */
export function digitGroups(value: number): string {
  return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, '\u00A0');
}

/**
 * Подпись номера версии — «версия 0004».
 *
 * Отдельная функция, потому что эта строка встречается на восьми экранах, и
 * писать её руками значит однажды написать «версия 4». Через неё же проходят
 * и списки, и очередь проверки, и карточка разбора.
 */
export function versionLabel(versionNo: number): string {
  return t('lib.versionLabel', { no: docNumber(versionNo) });
}
